import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";


const initialState = {
  value: [],
  loading: false,
};

export const updateStatOrders = createAsyncThunk(
  "statOrders/updateStatOrders",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateStatOrdersSlice = createSlice({
  name: "updateStatOrders",
  initialState,
  reducers: {
    clearUpdateStatOrdersResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateStatOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStatOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateStatOrders.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateStatOrdersList = (state) => state.updateStatOrders.value;
export const updateStatOrdersLoader = (state) => state.updateStatOrders.loading;
export const { clearUpdateStatOrdersResponse } = updateStatOrdersSlice.actions;

export default updateStatOrdersSlice.reducer;
